import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ContentOwnershipContributorsQueryNode, {
	type useContentOwnershipContributorsContentOwnershipContributorsQuery$data,
	type useContentOwnershipContributorsContentOwnershipContributorsQuery$variables,
} from './__generated__/useContentOwnershipContributorsContentOwnershipContributorsQuery.graphql.ts';
import { DEFAULT_CONTRIBUTORS_FETCH_LIMIT } from './contentOwnershipConstants.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadContentOwnershipContributors(contentId: string): Promise<{
	data: useContentOwnershipContributorsContentOwnershipContributorsQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<
		useContentOwnershipContributorsContentOwnershipContributorsQuery$data,
		useContentOwnershipContributorsContentOwnershipContributorsQuery$variables
	>({
		query: ContentOwnershipContributorsQueryNode,
		variables: { contentId, limit: DEFAULT_CONTRIBUTORS_FETCH_LIMIT },
	});
}
